(() => {
  const section = document.querySelector('[data-sxt-personal-recommendations]');
  if (!section) return;
  const grid = section.querySelector('.sxt-complete-look__grid');
  const vendor = section.dataset.sxtVendor;
  const sourceUrl = section.dataset.sxtProductUrl;
  const sourceGroup = section.dataset.sxtSourceGroup;
  const sourceGender = section.dataset.sxtGender;
  const sourceColorGroup = section.dataset.sxtColorGroup;
  const sourcePrice = Number(section.dataset.sxtSourcePrice || 0);
  if (!grid || !vendor) return;
  const originalCards = [...grid.children];
  const localeRoot = new URL(sourceUrl, location.origin).pathname.split('/products/')[0];
  const route = path => localeRoot + path;
  grid.classList.add('is-loading');
  if (!grid.children.length) grid.innerHTML = '<li class="sxt-rec-skeleton"></li><li class="sxt-rec-skeleton"></li><li class="sxt-rec-skeleton"></li><li class="sxt-rec-skeleton"></li>';

  const normalize = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const groupFor = (product) => {
    const text = normalize(`${product.type || ''} ${product.title || ''} ${(product.tags || []).join?.(' ') || product.tags || ''}`);
    if (/чант|bag|backpack/.test(text)) return 'bag';
    if (/обув|shoe|sneaker|boot|сандал/.test(text)) return 'shoes';
    if (/рокл|dress/.test(text)) return 'dress';
    if (/пантал|дънк|пола|trouser|jean|skirt/.test(text)) return 'bottom';
    if (/блуз|риза|тениск|shirt|blouse|t-shirt|\btop\b/.test(text)) return 'top';
    if (/палто|яке|сако|coat|jacket|blazer/.test(text)) return 'outerwear';
    if (/аксесоар|колан|бижу|шал|шап|accessor|belt|jewel|scarf|hat|cap/.test(text)) return 'accessory';
    return 'other';
  };
  const genderFor = (product) => {
    const text = normalize(`${product.type || ''} ${product.title || ''} ${(product.tags || []).join?.(' ') || product.tags || ''}`);
    if (/жена|дамск|women|woman|female/.test(text)) return 'female';
    if (/мъж|male|(^|\s)men(\s|$)|(^|\s)man(\s|$)/.test(text)) return 'male';
    return 'neutral';
  };
  const colorGroupsFor = (product) => {
    const options = product.options || [];
    const colorIndex = options.findIndex((option) => /color|colour|цвят/.test(normalize(typeof option === 'string' ? option : option.name)));
    if (colorIndex < 0) return [];
    return [...new Set((product.variants || []).filter((variant) => variant.available).map((variant) => {
      const color = normalize(variant.options?.[colorIndex]);
      if (/чер|black|бял|white|сив|grey|gray|беж|beige|каф|brown|cream|екрю|ecru/.test(color)) return 'neutral';
      if (/черв|red|роз|pink|оранж|orange|жълт|yellow|gold|бордо|burgundy|wine/.test(color)) return 'warm';
      if (/син|blue|зелен|green|лилав|purple|navy|тюркоаз|turquoise/.test(color)) return 'cool';
      return color;
    }).filter(Boolean))];
  };
  const productCache = new Map();
  const safeFetch = async url => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try { return await fetch(url, { credentials: 'same-origin', signal: controller.signal }); }
    finally { clearTimeout(timer); }
  };
  const productJSON = path => {
    if (!productCache.has(path)) productCache.set(path, safeFetch(path + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
    return productCache.get(path);
  };
  const mapLimited = async (items, fn) => {
    const values = new Array(items.length);
    let index = 0;
    await Promise.all(Array.from({ length: Math.min(6, items.length) }, async () => {
      while (index < items.length) { const current = index++; values[current] = await fn(items[current]); }
    }));
    return values;
  };

  const loadVendorPage = async (page) => {
    const url = `${route('/collections/vendors')}?q=${encodeURIComponent(vendor)}&page=${page}`;
    const html = await safeFetch(url).then((response) => response.ok ? response.text() : '');
    const documentCopy = new DOMParser().parseFromString(html, 'text/html');
    return [...documentCopy.querySelectorAll('#product-grid > .grid__item')].slice(0, 18).map((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      return link ? { card, path: new URL(link.href, location.origin).pathname } : null;
    }).filter(Boolean);
  };

  const loadCollectionPage = async (path, page) => {
    const separator = path.includes('?') ? '&' : '?';
    const html = await safeFetch(`${route(path)}${separator}page=${page}`).then((response) => response.ok ? response.text() : '');
    const documentCopy = new DOMParser().parseFromString(html, 'text/html');
    return [...documentCopy.querySelectorAll('#product-grid > .grid__item')].slice(0, 24).map((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      return link ? { card, path: new URL(link.href, location.origin).pathname } : null;
    }).filter(Boolean);
  };

  const run = async () => {
    const selected = [];
    const seen = new Set([new URL(sourceUrl, location.origin).pathname]);
    const collect = async (cards, brandMatch) => {
      const uniqueCards = cards.filter(({ path }) => !seen.has(path));
      uniqueCards.forEach(({ path }) => seen.add(path));
      const products = await mapLimited(uniqueCards, ({ path }) => productJSON(path));
      uniqueCards.forEach((entry, index) => {
        const product = products[index];
        if (!product || !product.available || groupFor(product) === sourceGroup) return;
        const gender = genderFor(product);
        if (gender !== 'neutral' && gender !== sourceGender) return;
        const productPrice = Number(product.price || 0);
        const priceDistance = sourcePrice > 0 && productPrice > 0 ? Math.abs(productPrice - sourcePrice) / sourcePrice : 99;
        selected.push({ ...entry, product, brandMatch, colorMatch: Boolean(sourceColorGroup) && colorGroupsFor(product).includes(sourceColorGroup), priceDistance });
      });
    };

    for (let page = 1; page <= 2; page += 1) {
      const cards = await loadVendorPage(page);
      await collect(cards, true);
    }
    if (selected.length < 4) {
      const genderPath = sourceGender === 'male' ? '/collections/есен-зима-мъж' : '/collections/есен-зима-жена';
      for (let page = 1; page <= 1 && selected.length < 4; page += 1) {
        await collect(await loadCollectionPage(genderPath, page), false);
      }
    }
    if (selected.length < 4) {
      for (let page = 1; page <= 1 && selected.length < 4; page += 1) {
        await collect(await loadCollectionPage('/collections/all', page), false);
      }
    }
    const priority = (item) => item.brandMatch && item.colorMatch ? 0 : item.brandMatch ? 1 : item.colorMatch ? 2 : 3;
    selected.sort((a, b) => priority(a) - priority(b) || a.priceDistance - b.priceDistance);
    if (!selected.length) {
      grid.replaceChildren(...originalCards);
      grid.classList.remove('is-loading');
      if (!originalCards.length) section.hidden = true;
      return;
    }
    const existing = originalCards;
    const replacements = selected.slice(0, 4).map(({ card }) => {
      card.querySelectorAll('script,link').forEach((element) => element.remove());
      return card;
    });
    const replacementPaths = new Set(replacements.map((card) => new URL(card.querySelector('a[href*="/products/"]').href, location.origin).pathname));
    const fallback = existing.filter((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      return link && !replacementPaths.has(new URL(link.href, location.origin).pathname);
    });
    grid.replaceChildren(...replacements, ...fallback.slice(0, Math.max(0, 4 - replacements.length)));
    grid.classList.remove('is-loading');
    section.dataset.sxtBrandMatched = String(replacements.length);
  };
  const start = () => run().catch(() => {
    grid.replaceChildren(...originalCards);
    grid.classList.remove('is-loading');
    if (!originalCards.length) section.hidden = true;
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { observer.disconnect(); start(); }
    }, { rootMargin: '300px' });
    observer.observe(section);
  } else start();
})();
